module.exports = __webpack_public_path__ + "static/media/logo_cn_nl.b006a687.svg";